export default {
    "email":"Email",
    "whatsApp":"WhatsApp",
    "talk":"Let's Talk",
    "factory":"Visit Factory",
    "phone":"0086-15817481923",
    "address":"Dongguan, Guangdong",

    "contactUs":"Contact Us",
    "quote":"Get A Free Quote",
    "meanwhile":"A full catalog will be sent meanwhile.",
    "fullName":"Full Name",
    "usEmail":"Email",
    "telephone":"Telephone",
    "message":"Message",
    "spam":"Your information will not be used for spam.",
    "send":"Send"
};
  